export const TRACKING_PANEL_TEST_ID = 'TrackingPanel';
